import React from 'react';
import { Button, Dialog, ModalPortal } from '@hoffmann/pattern-library-2';
import { useTranslate } from 'react-translate-plus';
import styled from 'styled-components';
import { withStyledClasses } from 'styled/withStyledClasses';
import { CustomerInformation } from './CustomerInformation';

interface Props {
  onClose: () => void;
  configurationState?: string;
  requestInfo: SimpleProjectServiceAPI.ConfigurationRequestDto;
}

export const CustomerInformationModal: React.FC<Props> = ({ onClose, ...rest }) => {
  const t = useTranslate('CustomerInformationModal');

  return (
    <StyledModalPortal isOpen={true}>
      <Dialog
        title={t('TITLE')}
        size={200}
        actions={[<Button key="cancelBtn" label={t('BUTTON_CANCEL')} ghost onClick={onClose} />]}
      >
        <Content>
          <CustomerInformation {...rest} />
        </Content>
      </Dialog>
    </StyledModalPortal>
  );
};

const StyledModalPortal = styled(withStyledClasses(ModalPortal))`
  .hpl2-Dialog--size-200 .hpl2-Dialog__header,
  .hpl2-Dialog--size-200 .hpl2-Dialog__content,
  .hpl2-Dialog--size-200 .hpl2-Dialog__footer {
    max-width: 700px;
    width: 700px;
  }
`;

const Content = styled.div``;
